import { render, staticRenderFns } from "./NotificationBannerToast.vue?vue&type=template&id=6e654886&"
import script from "./NotificationBannerToast.vue?vue&type=script&lang=ts&"
export * from "./NotificationBannerToast.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationBannerToast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports